import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../../../hooks/useFetch";

const TaxRegisterOverseas = ({taxMeta = null}) => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState?.user?._id;
  const [subscriptions, setSubscriptions] = useState([]);
  const [taxRegisterData, setTaxRegisterData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState({ text: '', type: '' });
  const showMessage = (text, type = "success") => {
      setMessage({ text, type });
  };

  const fetchTaxRegisterOverseas = async () => {
    if (!selectedCountry ||!selectedMonth ||!selectedYear) {
        showMessage( "Please select Country, Month and Year", "error");
        return;
    }

    setLoading(true);

    try {
        const config = {
            url: "/pd/tax-register-overseas",
            method: "post",
            data: {
                countryCode: selectedCountry,
                month: selectedMonth,
                year: selectedYear,
            },
            headers: { Authorization: authState.token},
        };
        const response = await fetchData(config,{ silent: true });
        if (response?.status) {
            setTaxRegisterData(response?.data || []);
        }
    }
    catch (err) {
        console.error("Tax Register Error", err
        );
        showMessage("Failed to load tax register","error");
    }
    setLoading(false);
  };

  const totals = taxRegisterData.reduce(
      (acc, item) => {
          acc.baseAmount += Number(item.baseAmount || 0);
          acc.tax += Number(item.tax || 0);
          acc.finalAmount += Number(item.finalAmount || 0);
          return acc;
      },
      {
          baseAmount: 0,
          tax: 0,
          finalAmount: 0,
      }
  );

  return (
    <div className="p-2">
      <div className="mb-2 flex flex-wrap items-end gap-3">
          <select
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
              className="h-8 bg-gray-800 text-white border rounded p-1 text-xs"
          >
              <option value="">Country</option>
              <option value="AE">UAE</option>
              <option value="SA">Saudi Arabia</option>
              <option value="OM">Oman</option>
              <option value="QA">Qatar</option>
              <option value="KW">Kuwait</option>
          </select>

          <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="h-8 bg-gray-800 text-white border rounded p-1 text-xs"
          >
              <option value="">Month</option>

              {[
                  "January", "February", "March", "April",
                  "May", "June", "July", "August",
                  "September", "October", "November", "December"
              ].map((month, index) => (
                  <option key={index + 1} value={index + 1}>
                      {month}
                  </option>
              ))}
          </select>

          <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="h-8 bg-gray-800 text-white border rounded p-1 text-xs"
          >
              <option value="">Year</option>
              {[2026, 2025, 2024].map(year => (
                  <option key={year} value={year}>
                      {year}
                  </option>
              ))}
          </select>

          <button
              onClick={fetchTaxRegisterOverseas}
              className="h-8 p-1 w-24 text-xs rounded bg-blue-600 text-white"
          >
              Show
          </button>
      </div>

      <div className="p-4 space-y-6">
          <div className="bg-gray-800">
              <h2 className="mb-3 text-sm lg:text-lg text-cyan-200 font-bold">
                  {selectedCountry} Sales Tax Register
              </h2>
              <table className="w-full border">
                  <thead className="bg-gray-700">
                      <tr>
                          <th className="border p-1 text-xs text-gray-100">Customer</th>
                          <th className="border p-1 text-xs text-gray-100">Invoice No</th>
                          <th className="border p-1 text-xs text-gray-100 text-right">Gross</th>
                          <th className="border p-1 text-xs text-gray-100 text-right">Tax</th>
                          <th className="border p-1 text-xs text-gray-100 text-right">Total</th>
                          <th className="border p-1 text-xs text-gray-100">Date</th>
                      </tr>
                  </thead>
                  <tbody>
                    {!taxRegisterData.length ? (
                        <tr>
                            <td colSpan={6} className="border p-4 text-xs text-center text-gray-100">
                                No Records Found
                            </td>
                        </tr>
                    ) : (
                        <>
                            {taxRegisterData.map(item => (
                                <tr key={item._id}>
                                    <td className="border p-1 text-xs text-gray-100">
                                        {item.userName}
                                    </td>

                                    <td className="border p-1 text-xs text-gray-100">
                                        {item.invoiceNumber}
                                    </td>

                                    <td className="border p-1 text-xs text-gray-100 text-right">
                                        {item.currencySymbol} {Number(item.baseAmount || 0).toFixed(2)}
                                    </td>

                                    <td className="border p-1 text-xs text-gray-100 text-right">
                                        {item.currencySymbol} {Number(item.tax || 0).toFixed(2)}
                                    </td>

                                    <td className="border p-1 text-xs text-gray-100 text-right">
                                        {item.currencySymbol} {Number(item.finalAmount || 0).toFixed(2)}
                                    </td>

                                    <td className="border p-1 text-xs text-gray-100">
                                        {item.dateCreated
                                            ? new Date(item.dateCreated).toLocaleDateString()
                                            : "-"}
                                    </td>
                                </tr>
                            ))}

                            <tr className="bg-gray-900 font-bold">
                                <td
                                    colSpan={2}
                                    className="border p-1 text-xs text-right text-yellow-400"
                                >
                                    TOTAL
                                </td>

                                <td className="border p-1 text-xs text-right text-yellow-400">
                                    {taxRegisterData[0]?.currencySymbol} {totals.baseAmount.toFixed(2)}
                                </td>

                                <td className="border p-1 text-xs text-right text-yellow-400">
                                    {taxRegisterData[0]?.currencySymbol} {totals.tax.toFixed(2)}
                                </td>

                                <td className="border p-1 text-xs text-right text-yellow-400">
                                    {taxRegisterData[0]?.currencySymbol} {totals.finalAmount.toFixed(2)}
                                </td>

                                <td className="border p-1"></td>
                            </tr>
                        </>
                    )}
                </tbody>
              </table>
          </div>

          <div>
              <h2 className="mb-3 text-sm lg:text-lg text-cyan-200 font-bold">
                  Reverse Charge Register
              </h2>
              <div className="grid gap-2 rounded border bg-gray-700 text-white p-1">
                  <div className="text-xs text-gray-100"><b>Country:</b> {selectedCountry || "N/A"}</div>
                  <div className="text-xs text-gray-100"><b>Tax Type:</b> {taxMeta?.taxType || "N/A"}</div>
                  <div className="text-xs text-gray-100"><b>Reverse Charge:</b> {taxMeta?.reverseCharge ? "Applicable" : "Not Applicable"}</div>
                  <div className="text-xs text-gray-100"><b>Tax Registration:</b> {taxMeta?.registrationNumber || "N/A"}</div>
              </div>
          </div>
      </div>
    </div>
  );
};

export default TaxRegisterOverseas;